import React from 'react';
import styles from './buttonContainer.module.scss';
import ButtonComponent from '../../common/buttons/ButtonComponent/ButtonComponent';
import { buttonVariants } from '../../common/buttons/types';

export default function ButtonContainer({ primaryText, secondaryText, back, actionCall }) {
  return (
    <div className={styles.buttonContainer}>
      <ButtonComponent variant={buttonVariants.SECONDARY} text={primaryText} action={back} />
      <ButtonComponent variant={buttonVariants.PRIMARY} text={secondaryText} action={actionCall} />
    </div>
  );
}
